import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import {
  CompanyAvatar,
  CompanyAvatarFallback,
  CompanyMeta,
  CompanyMetaColumn,
  CompanyName,
  HeaderCompanyCard,
} from "./staffRegisterView.styled";

export const StaffRegisterCompanyCard = (): JSX.Element => {
  const { t } = useTranslation();
  const [companyState] = useCompanyStore();
  const companyName =
    companyState.company?.companyName ?? companyState.company?.legalName ?? "";
  const registrationNumber = companyState.company?.registrationNumber ?? "-";
  const address = companyState.company?.address ?? "-";
  const city = companyState.company?.city ?? "-";
  const avatarUrl = companyState.companyImage ?? "";

  const initials = useMemo((): string => {
    const parts = companyName.trim().split(/\s+/);
    const letters = parts
      .map((part) => part[0])
      .slice(0, 2)
      .join("");
    return letters.toUpperCase();
  }, [companyName]);

  return (
    <HeaderCompanyCard>
      {avatarUrl ? (
        <CompanyAvatar src={avatarUrl} alt={`${companyName} logo`} />
      ) : (
        <CompanyAvatarFallback>{initials}</CompanyAvatarFallback>
      )}
      <CompanyMetaColumn>
        <CompanyName>{companyName}</CompanyName>
        <CompanyMeta>
          {t("TimeReports.OrganizationNumber")}: {registrationNumber}
        </CompanyMeta>
        <CompanyMeta>
          {address}, {city}
        </CompanyMeta>
      </CompanyMetaColumn>
    </HeaderCompanyCard>
  );
};
